import { PERCENTAGE_BREAKDOWN_PARTS } from './percentageBreakdownParts';
import type { PercentageBreakdownStyleConfig } from './types';

export const PERCENTAGE_BREAKDOWN_STYLE_CONFIG: PercentageBreakdownStyleConfig =
  {
    parts: PERCENTAGE_BREAKDOWN_PARTS,
    baseStyle: {
      container: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      },
      bar: {
        display: 'flex',
        width: '100%',
        height: 1,
        gap: '1px',
        borderRadius: 'md',
        overflow: 'hidden',
        backgroundColor: 'page.surface',
      },
      barSegment: {
        height: '100%',
        minWidth: 0,
      },
      tooltip: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, max-content)',
        rowGap: 0.25,
        columnGap: 2,
        fontSize: 'sm',
      },
      tooltipItemLabel: {
        color: 'feature.onInteraction',
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        fontWeight: 'medium',
      },
      tooltipItemDot: {
        width: 1,
        height: 1,
        borderRadius: 'full',
      },
      tooltipItemValue: {
        color: 'feature.onInteraction',
        textAlign: 'right',
        width: '100%',
      },
      tooltipMessage: {
        color: 'feature.onInteraction',
        fontWeight: 'medium',
        whiteSpace: 'normal',
        mt: 1,
        minWidth: 14,
      },
    },
    sizes: {
      sm: {
        bar: {
          height: 0.75,
        },
        tooltipItemDot: {
          width: 0.75,
          height: 0.75,
        },
        tooltip: {
          fontSize: 'xs',
        },
      },
      md: {
        bar: {
          height: 1,
        },
        tooltipItemDot: {
          width: 1,
          height: 1,
        },
        tooltip: {
          fontSize: 'sm',
        },
      },
      lg: {
        bar: {
          height: 1.5,
        },
        tooltipItemDot: {
          width: 1.25,
          height: 1.25,
        },
        tooltip: {
          fontSize: 'md',
        },
      },
    },
    defaultProps: {
      size: 'md',
    },
  };
